// FullCalendar
import { Calendar, formatDate } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr';
import moment from 'moment';

export default function (options) {
	const _defaultSettings = {
			  getUrl: null,
			  addUrl: null,
			  updateUrl: null,
			  deleteUrl: null,
			  deleteRecurringUrl: null,
			  schedules: {},
			  minTime: '06:00:00',
			  maxTime: '24:00:00',
		  },
		  _settings        = { ..._defaultSettings, ...options },
		  _comps           = {
			  $deleteRecurringEventModal: $('#deleteRecurringEventModal'),
			  $deleteRecurringEventForm: $('#deleteRecurringEventForm'),
		  };
	let _calendar          = null;

	/**
	 * Init function
	 */
	function init () {
		_initCalendar(); // init fcCalendar
		_onClickPopoverClose(); // close une popover
		_onClickSaveScheduleForm(); // save un formulaire d'edit dans une popover
		_onClickDeleteSchedule(); // on click bouton pour suppr un event
		_onShowDeleteRecurringModal(); // on show une modal de suppr
		_onSubmitDeleteRecurringEventForm(); // delete un recurring event
	}

	//=======================================================
	//======================= FUNCTIONS =====================

	/**
	 * Init FullCalendar
	 */
	function _initCalendar () {
		const calendarEl = document.getElementById('calendar');

		_calendar = new Calendar(calendarEl, {
			plugins: [timeGridPlugin, interactionPlugin],
            events: {
                url: _settings.getUrl,
                method: 'GET',
                extraParams: _settings.params,
                failure: function(e) {
                    alert('there was an error while fetching events!',e);
                },
            },
			locale: frLocale,
			contentHeight: 'auto',
			defaultView: 'timeGridWeek',
			minTime: _settings.minTime,
			maxTime: _settings.maxTime,
			slotDuration: '01:00:00',
			snapDuration: '00:15:00',
			header: {
				left: 'today',
				center: 'title',
				right: 'prev,next',
			},
			selectable: false,
			selectOverlap: false,
			eventOverlap: false,
			eventConstraint: {
				startTime: _settings.minTime,
				endTime: _settings.maxTime,
			},
			// empêcher un event de s'étaler sur plusieurs jours
			selectAllow: function (info) {
				return info.start.getDay() === info.end.getDay();
			},
			editable: false,
			selectMirror: true,
			forceEventDuration: true,
			allDaySlot: false,
			// Permettre de rendre du html
			eventRender (info) {
				$(info.el).find('.fc-title').html(info.event.title);
			},
			datesRender () {
				$('.popover').popover('hide');
			},
			// Ajouter un event
			select (info) {
				_fcCreateSchedule(info);
			},
			// Déplacer un event
			eventDrop (info) {
				if ($(info.el).data('bs.popover') !== undefined) {
					$(info.el).popover('dispose');
				}
				_fcUpdateSchedule(info.event);
			},
			// Resize un event
			eventResize (info) {
				if ($(info.el).data('bs.popover') !== undefined) {
					$(info.el).popover('dispose');
				}
				_fcUpdateSchedule(info.event);
			},
			// Afficher la popover au click
			eventClick (info) {
				// _showEventPopover($(info.el), info.event);
			}
		});

		// Construire le calendrier dans la page HTML
		_calendar.render();
	}

	/**
	 * Ajouter event en bdd
	 *
	 * @param eventInfo
	 */
	function _fcCreateSchedule (eventInfo) {
		const start_at = _strDate(eventInfo.start),
			  end_at   = _strDate(eventInfo.end);

		axios.post(_settings.addUrl, {
			start_at,
			end_at,
		}).then(function (r) {
			// _calendar.addEvent({
			// 	...eventInfo,
			// 	...{ id: r.data.id }
			// });
			_calendar.refetchEvents();
			$.jGrowl('La plage horaire a été ajoutée', { position: 'bottom-right', theme: 'bg-success' });
		}).catch(function (e) {
			console.error(e);
			_showError(e);
		});
	}

	/**
	 * Modifier event en bdd après event FullCalendar (resize, move…)
	 *
	 * @param eventInfo
	 */
	function _fcUpdateSchedule (eventInfo) {
		const start_at = _strDate(eventInfo.start),
			  end_at   = _strDate(eventInfo.end);

		axios.post(_settings.updateUrl, {
			id: eventInfo.id,
			start_at,
			end_at,
			price_increase: eventInfo.extendedProps.price_increase,
		}).then(function (r) {
			_calendar.refetchEvents();
			$.jGrowl('La plage horaire a été modifiée', { position: 'bottom-right', theme: 'bg-success' });
		}).catch(function (e) {
			console.error(e);
			_showError(e);
		});
	}

	/**
	 * Afficher une popover au click d'un event
	 *
	 * @param $el
	 * @param event
	 * @private
	 */
	function _showEventPopover ($el, event) {
		if ($el.data('bs.popover') === undefined) {
			$el.popover({
				container: 'body',
				template: `<div class="popover popover--schedule" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>`,
				html: true,
				sanitize: false,
				content: () => {
					const $popoverContent = $('#popoverScheduleContentPrototype').clone(),
						  isRepeating     = event.extendedProps.start_repeat !== null && event.extendedProps.start_repeat !== undefined;

					return $popoverContent
						.find('.delete-schedule').attr('data-id', event.id).attr('data-date', _strDate(event.start)).end()
						.find('.js-schedule-id').attr('value', event.id).end()
						.find('.js-fc-event-start').attr('value', _strDate(event.start)).end()
						.find('.js-fc-event-end').attr('value', _strDate(event.end)).end()
						.find('.js-schedule-price-increase').attr('value', event.extendedProps.price_increase).end()
						.find('.js-schedule-repeat-checkbox label').attr('for', 'input_repeat_' + event.id).end()
						.find('.js-schedule-repeat-checkbox input').attr('checked', isRepeating ? 'checked' : null).attr('id', 'input_repeat_' + event.id).end()
						.html();
				},
			}).on('inserted.bs.popover', function () {
				$('.fc-event').not(this).popover('hide');
			}).popover('show');
		}
	}

	/**
	 * Afficher une popup d'erreur
	 *
	 * @param e
	 */
	function _showError (e) {
		$.jGrowl("Une erreur est survenue. Si l'erreur persiste, contactez-nous.", { position: 'bottom-right', theme: 'bg-danger' });
	}

	//=======================================================
	//======================== EVENTS =======================

	/**
	 * Fermer une popover
	 */
	function _onClickPopoverClose () {
		$(document).on('click', '.popover__actions .close-popover', function (e) {
			e.preventDefault();
			$(this).parents('.popover').popover('hide');
		});
	}

	/**
	 * Sauvegarder le formulaire d'édition d'un Schedule
	 */
	function _onClickSaveScheduleForm () {
		$(document).on('click', '#popoverScheduleForm .save-schedule-form', function () {
			const $inputsContainer = $(this).parents('#popoverScheduleForm'),
				  $popover         = $(this).parents('.popover'),
				  data             = {
					  ..._inputsToArray($inputsContainer),
					  fromUpdateForm: true, // utilisé par le Controller
				  };

			axios.post(_settings.updateUrl, data).then(function (r) {
				_calendar.refetchEvents();
				$popover.popover('dispose');
				$.jGrowl('La plage horaire a été modifiée', { position: 'bottom-right', theme: 'bg-success' });
			}).catch(function (e) {
				console.error(e);
				_showError(e);
			});
		});
	}

	/**
	 * Retourner les valeurs d'inputs dans un array
	 * @private
	 */
	function _inputsToArray ($inputsContainer) {
		const data = {};

		$inputsContainer.find('input').each((key, input) => {
			if ($(input).attr('type') === 'checkbox') {
				if ($(input).is(':checked')) {
					data[$(input).attr('name')] = $(input).val();
				}
			} else {
				data[$(input).attr('name')] = $(input).val();
			}
		});

		return data;
	}

	/**
	 * Supprimer un event
	 */
	function _onClickDeleteSchedule () {
		$(document).on('click', '.popover__actions .delete-schedule', function () {
			const $popover = $(this).parents('.popover'),
				  id       = $(this).attr('data-id'),
				  date     = $(this).attr('data-date'),
				  event    = _calendar.getEventById(id);

			if (event.extendedProps.is_recurring) {
				_comps.$deleteRecurringEventModal
					.find('#deleteRecurringEventInputId').val(id).end()
					.find('#deleteRecurringEventInputDate').val(date).end()
					.modal('show');
			} else {
				if (confirm('Supprimer la plage horaire ?')) {
					axios.post(_settings.deleteUrl, {
						id: id,
					}).then(function (r) {
						$popover.popover('dispose');
						_calendar.getEventById(r.data.event_id).remove();
						$.jGrowl('La plage horaire a été supprimée', { position: 'bottom-right', theme: 'bg-info' });
					}).catch(function (e) {
						console.error(e);
						_showError(e);
					});
				}
			}
		});
	}

	/**
	 * A l'ouverture de la modal de suppression d'un recurring event
	 *
	 * @private
	 */
	function _onShowDeleteRecurringModal () {
		_comps.$deleteRecurringEventModal.on('show.bs.modal', () => {
			$('.popover').popover('hide');
		});
	}

	/**
	 * Submit ajax du formulaire de suppression d'un recurring event
	 *
	 * @private
	 */
	function _onSubmitDeleteRecurringEventForm () {
		_comps.$deleteRecurringEventForm.on('submit', function (e) {
			e.preventDefault();

			const $form     = $(this),
				  actionUrl = $form.attr('action');

			axios.post(actionUrl,
				_comps.$deleteRecurringEventForm.serialize(),
			).then((r) => {
				_comps.$deleteRecurringEventModal.modal('hide');
				_calendar.getEventById(r.data.event_id).remove();
				$.jGrowl('La plage horaire périodique a été supprimée', { position: 'bottom-right', theme: 'bg-info' });
			}).catch((e) => {
				console.error(e);
				_showError(e);
			});
		});
	}

	/**
	 * Formater une date en une chaîne de caractères standard
	 *
	 * @param date
	 * @returns {string}
	 * @private
	 */
	function _strDate (date) {
		if (!moment.isMoment(date)) {
			date = moment(date);
		}
		return date.format('YYYY-MM-DD HH:mm:ss');
	}

	init();
};
